module.exports = __webpack_public_path__ + "static/img/huozhu.70b050e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_productcenter/huozhu.png
// module id = 0dBE
// module chunks = 1